function initMlgtsSlider() {
  var swiper = new Swiper(".MlgtsSwiper", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
    loop: true, 
  });
}


function swiperinitialized() {
    console.log('Swiper initialization function called');
    var swiperElement = document.querySelector('.mvidSwiper');
    if (!swiperElement) {
        console.error('Swiper element not found');
        return;
    }

    // Destroy existing Swiper instance if it exists
    if (swiperElement.swiper) {
        console.log('Destroying existing Swiper instance');
        swiperElement.swiper.destroy(true, true);
    }

    var swiper = new Swiper(swiperElement, {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: { slidesPerView: 3, spaceBetween: 15 },
            1024: { slidesPerView: 5, spaceBetween: 15 },
            1280: { slidesPerView: 5, spaceBetween: 15 }, 
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true, 
        },
        on: {
            init: function () {
                console.log('Swiper initialized');
                // Autoplay the first video when Swiper is initialized
                const firstVideo = swiperElement.querySelector('.vm-video');
                const firstPlayButton = swiperElement.querySelector('.m-play-button-container');
                if (firstVideo) {
                    firstVideo.muted = true; // Mute the video for autoplay
                    firstVideo.play().then(() => {
                        console.log('First video autoplayed');
                        // Hide the play button when the video starts playing
                        if (firstPlayButton) {
                            firstPlayButton.style.opacity = 0;
                        }
                    }).catch((error) => {
                        console.error('Autoplay failed:', error);
                    });
                }
            },
        }
    });

    // Play/Stop Video and Toggle Play Button Opacity
    document.querySelectorAll('.m-play-button-container').forEach(button => {
        button.addEventListener('click', function () {
            var videoElement = this.closest('.m-video-slider-video').querySelector('.vm-video');
            if (videoElement.paused) {
                videoElement.play();
                this.style.opacity = 0; 
                console.log('Video playing');
            } else {
                videoElement.pause();
                this.style.opacity = 1; 
                console.log('Video paused');
            }
        });
    });

    // Automatically Replay Video When It Ends
    document.querySelectorAll('.vm-video').forEach(video => {
        video.addEventListener('ended', function () {
            console.log('Video ended, replaying');
            video.play(); 
        });
    });

    console.log('Swiper and event listeners set up');
}